(() => {
  const init = root => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const base = window.Shopify?.routes?.root || '/';
    const refreshCart = async () => {
      try {
        const response = await fetch(base + 'cart.js', {
          credentials: 'same-origin', cache: 'no-store', headers: {'Accept': 'application/json'}
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (Number.isFinite(cart.item_count)) {
          root.querySelectorAll('[data-cart-count]').forEach(count => {
            count.textContent = cart.item_count;
          });
        }
      } catch {}
    };
    refreshCart();
    window.addEventListener('pageshow', event => { if (event.persisted) refreshCart(); });
    let category = 'all';
    let expanded = false;
    const more = root.querySelector('[data-show-more]');
    const filterCards = () => {
      let matches = 0;
      root.querySelectorAll('[data-merch-card]').forEach(card => {
        const match = category === 'all' || card.dataset.category === category;
        if (match) matches++;
        card.hidden = !match || (!expanded && matches > 6);
      });
      const empty = root.querySelector('.ccbf-no-results');
      if (empty) empty.hidden = matches > 0;
      if (more) {
        more.hidden = matches <= 6;
        more.setAttribute('aria-expanded', String(expanded));
        more.firstChild.textContent = expanded ? more.dataset.less : more.dataset.more;
      }
    };
    root.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-filter]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      category = button.dataset.filter;
      expanded = false;
      filterCards();
    }));
    more?.addEventListener('click', () => { expanded = !expanded; filterCards(); });
    filterCards();
    const saleOpen = () => {
      const now = Date.now() / 1000;
      return now >= Number(root.dataset.saleStart) && now < Number(root.dataset.saleEnd);
    };
    root.querySelectorAll('form.ccbf-product-form').forEach(form => {
      const select = form.querySelector('[name="id"]');
      const button = form.querySelector('[data-buy]');
      const card = form.closest('.ccbf-product');
      const error = form.querySelector('.ccbf-product-error');
      const status = document.createElement('p');
      status.className = 'ccbf-product-status';
      status.setAttribute('role', 'status');
      status.hidden = true;
      form.append(status);
      const choices = Array.from(form.querySelectorAll('[data-variant-choice]'));
      const choicesGroup = form.querySelector('[data-variant-options]');
      if (choicesGroup) choicesGroup.hidden = false;
      const sync = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        if (select.value) {
          card.querySelector('[data-price]').textContent = option.dataset.price;
          const compare = card.querySelector('[data-compare]');
          compare.hidden = !option.dataset.compare;
          compare.textContent = option.dataset.compare;
        }
        button.disabled = !saleOpen() || !select.value || option.dataset.available !== 'true';
        button.firstChild.textContent = !saleOpen()
          ? (Date.now() / 1000 >= Number(root.dataset.saleEnd) ? root.dataset.after : button.dataset.saleLabel)
          : !select.value ? button.dataset.choiceLabel
          : option.dataset.available !== 'true' ? button.dataset.sold : button.dataset.label;
        choices.forEach(choice => { choice.checked = choice.value === select.value; });
        error.hidden = true;
        status.hidden = true;
      };
      select.addEventListener('change', sync);
      choices.forEach(choice => choice.addEventListener('change', () => {
        if (!choice.checked || choice.disabled || form.getAttribute('aria-busy') === 'true') return;
        select.value = choice.value;
        sync();
      }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.getAttribute('aria-busy') === 'true') return;
        if (!saleOpen()) {
          sync();
          return;
        }
        if (!select.value || select.selectedOptions[0]?.dataset.available !== 'true') {
          error.textContent = !select.value ? button.dataset.choiceLabel : root.dataset.unavailable;
          error.hidden = false;
          return;
        }
        const variantId = select.value;
        form.setAttribute('aria-busy', 'true');
        button.disabled = true;
        select.disabled = true;
        choices.forEach(choice => { choice.disabled = true; });
        button.firstChild.textContent = root.dataset.adding;
        error.hidden = true;
        status.hidden = true;
        try {
          const response = await fetch(base + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || root.dataset.error);
          status.replaceChildren(document.createTextNode(root.dataset.added + ' '));
          const basketLink = document.createElement('a');
          basketLink.href = root.dataset.cartUrl;
          basketLink.textContent = root.dataset.viewBasket + ' ↗';
          status.append(basketLink);
          status.hidden = false;
          await refreshCart();
        } catch (problem) {
          error.textContent = problem.message || root.dataset.error;
          error.hidden = false;
        } finally {
          select.disabled = false;
          choices.forEach(choice => { choice.disabled = choice.dataset.available !== 'true'; });
          button.disabled = !saleOpen();
          button.firstChild.textContent = saleOpen() ? button.dataset.label : root.dataset.after;
          form.removeAttribute('aria-busy');
        }
      });
      sync();
    });
  };
  const dismissSignup = () => {
    const modal = document.querySelector('[data-kl-scroll-locking-modal="true"]');
    const close = modal?.querySelector('button.klaviyo-close-form');
    if (close) close.click();
  };
  if (document.body.classList.contains('ccbf-body')) {
    const signupObserver = new MutationObserver(changes => {
      if (changes.some(change => change.addedNodes.length)) dismissSignup();
    });
    signupObserver.observe(document.body, {childList: true, subtree: true});
    dismissSignup();
  }
  document.querySelectorAll('[data-campaign]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-campaign]').forEach(init));
})();
